import { observable, makeObservable } from "mobx";

export default class ActualProgressEntry {

  period = 0;
  progress = 0;
  actualCost = 0;
  anticipatedCost = 0;
  note = "";

  constructor(
    project,
    taskOrSummary,
    period,
    progress,
    actualCost,
    anticipatedCost,
    note
  ) {
    this.taskOrSummary = taskOrSummary;
    this.project = project;
    this.period = period;
    this.progress = progress;
    this.actualCost = actualCost;
    this.anticipatedCost = anticipatedCost;
    this.note = note;

    makeObservable(this, {
      period: observable,
      progress: observable,
      actualCost: observable,
      anticipatedCost: observable,
      note: observable
    })
  }

  toJS() {
    return {
      period: this.period,
      progress: +this.progress,
      actualCost: +this.actualCost,
      anticipatedCost: +this.anticipatedCost,
      note: this.note,
    };
  }

  static fromJS(store, object) {
    const entry = new ActualProgressEntry();
    if (object != null) {
      entry.period = object.period;
      entry.progress = object.progress;
      entry.actualCost = object.actualCost;
      entry.anticipatedCost = object.anticipatedCost;
      entry.note = object.note;
      entry.project = store;
    }
    return entry;
  }
}
